<template>
  <vue-dialog :dialog-data="dialogData" @confirm="confirm">
    <el-form :model="form" label-width="auto" :rules="rules" ref="form" size="small">
      <el-form-item label="设备SN" prop="sn">
        <el-input :value="form.sn" disabled/>
      </el-form-item>
      <el-form-item label="设备名" prop="name">
        <el-input v-model.trim="form.name" clearable/>
      </el-form-item>
      <el-form-item label="自定义名称" prop="name_x">
        <el-input v-model.trim="form.name_x" clearable/>
      </el-form-item>
      <el-form-item label="设备型号" prop="model">
        <el-input v-model.trim="form.model" clearable/>
      </el-form-item>
      <el-form-item label="自定义型号" prop="model_x">
        <el-input v-model.trim="form.model_x" clearable/>
      </el-form-item>
      <el-form-item label="硬件平台" prop="plat">
        <el-select v-model="form.plat" filterable>
          <el-option v-for="(item, index) in platformType" :key="index" :label="item" :value="item"/>
        </el-select>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input v-model="form.remark" type="textarea" :rows="3" clearable resize="none" :maxlength="128" placeholder="请填写申请人、申请说明"/>
      </el-form-item>
    </el-form>
  </vue-dialog>
</template>

<script>
  import {changeEmpty, checkNameModel, inputEmpty} from "@utils/validate"
  import {platformType} from "@utils/formatList"
  export default {
    name: "CustomDevice",
    props: {dialogData: Object},
    data() {
      return {
        platformType,
        form: {
          sn: "",
          name: "",
          name_x: "",
          model: "",
          model_x: "",
          plat: "",
          remark: "",
        },
        rules: {
          name: [inputEmpty("设备名"), checkNameModel()],
          name_x: [inputEmpty("自定义名称"), checkNameModel()],
          model: [inputEmpty("设备型号"), checkNameModel()],
          model_x: [inputEmpty("自定义型号"), checkNameModel()],
          plat: [changeEmpty("硬件平台")],
          remark: [inputEmpty("备注")]
        },
      }
    },
    created() {
      let row = this.dialogData.row;
      if (row) {
        Object.keys(this.form).forEach(key => key in row && (this.form[key] = row[key]));
      }
    },
    methods: {
      confirm() {
        this.$refs["form"].validate(async isOk => {
          if (isOk) {
            let nv = {
              device_custom_id: this.dialogData.row.id,
              ...this.form
            };
            let res = await this.$Http.reviseDevice(nv);
            if (res) {
              this.msgSuccess("修改成功");
              this.$emit("table-reload");
              this.dialogData.visible = false;
            }
          }
        });
      }
    }
  }
</script>

<style scoped>

</style>
